<template>
  <div class="main">
    <router-view></router-view>
    <!-- <div v-if="isMobile" class="service" @click="toCustomerService()">
      <div class="service_content">
        <div class="service_img" />
      </div>
    </div> -->
  </div>
</template>

<script>
const request_base_path = require("../utils/base_url");
export default {
  name: "Main",
  data() {
    return {
      isMobile: false, // 判断手机端字段
    };
  },
  computed: {
    menuid() {
      return this.$store.state.menuactiveid;
    },
  },
  watch: {},
  mounted() { },
  created() {
    this.getBrowserMobile();
  },
  methods: {
    // 判断浏览环境是手机端和pc端
    getBrowserMobile() {
      const regBrowser =
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;
      this.isMobile = navigator.userAgent.match(regBrowser) ? true : false; // 判断是否是手机浏览
      return this.isMobile;
    },
    // 进入客服
    // toCustomerService() {
    //   let strUrl = "";
    //   if (process.env.NODE_ENV == "development") {
    //     strUrl = request_base_path.dev_url + "#/customer";
    //   } else if (process.env.NODE_ENV == "production") {
    //     strUrl = request_base_path.pro_url + "#/customer";
    //   }
    //   window.open(strUrl, "_blank");
    // },
  },
  destroyed() { },
};
</script>
<style scoped lang="scss">
.main {
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;
  position: relative;

  .service {
    position: fixed;
    z-index: 99;
    bottom: calc(120px + 15%);
    right: calc(-6px + 1%);
    cursor: pointer;

    .service_content {
      overflow: hidden;

      .service_img {
        width: 56px;
        height: 160px;
        background: url("~@/assets/service/customer_service.png") no-repeat;
        background-position: center;
        background-size: cover;
      }
    }
  }

  .el_main {
    padding: 0 !important;
  }
}

@media screen and (max-width: 640px) {
  .main {
    padding: 0;

    .service {
      bottom: 100px;
      right: 5px;

      .service_content {
        .service_img {
          width: 40px;
          height: 114px;
        }
      }
    }
  }
}
</style>